import { MergeStrategyTypeId as MergeStrategyTypeId$1, BackPressure as BackPressure$1, BufferSliding as BufferSliding$1, isMergeStrategy as isMergeStrategy$1, isBackPressure as isBackPressure$1, isBufferSliding as isBufferSliding$1, match as match$1 } from '../../internal/channel/mergeStrategy.esm.js';

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category symbols
 */
const MergeStrategyTypeId = MergeStrategyTypeId$1;

/**
 * @since 2.0.0
 * @category symbols
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category models
 */

/**
 * @since 2.0.0
 * @category constructors
 */
const BackPressure = BackPressure$1;

/**
 * @since 2.0.0
 * @category constructors
 */
const BufferSliding = BufferSliding$1;

/**
 * Returns `true` if the specified value is a `MergeStrategy`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isMergeStrategy = isMergeStrategy$1;

/**
 * Returns `true` if the specified `MergeStrategy` is a `BackPressure`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isBackPressure = isBackPressure$1;

/**
 * Returns `true` if the specified `MergeStrategy` is a `BufferSliding`, `false`
 * otherwise.
 *
 * @since 2.0.0
 * @category refinements
 */
const isBufferSliding = isBufferSliding$1;

/**
 * Folds an `MergeStrategy` into a value of type `A`.
 *
 * @since 2.0.0
 * @category folding
 */
const match = match$1;

export { BackPressure, BufferSliding, MergeStrategyTypeId, isBackPressure, isBufferSliding, isMergeStrategy, match };
